import { render, staticRenderFns } from "./moveHistory.vue?vue&type=template&id=de956194&scoped=true&"
import script from "./moveHistory.vue?vue&type=script&lang=js&"
export * from "./moveHistory.vue?vue&type=script&lang=js&"
import style0 from "./moveHistory.vue?vue&type=style&index=0&id=de956194&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de956194",
  null
  
)

export default component.exports